import { useCurrentUserFeatures } from '../../shared/currentUser';

/**
 * 1P Brand Alignment
 *
 * The 1P brand alignment includes these two small but impactful changes across the application:
 * - All buttons and links will change from Spotify Green to Klein Blue
 * - All tabbed navigations (Creator Tape's `NavBar` component) will change to the 1P-branded variation (essentially sentence cased instead of all-caps)
 *
 * This work is currently in progress and is only visible to employees listed here:
 *
 * https://abtesting.spotify.net/features/6652/edit-overrides
 *
 * Once work is complete, this will be rolled out to users and the feature flag can eventually be deleted.
 *
 */

export const use1PBrandAlignment = () => {
  const userFeatures = useCurrentUserFeatures();
  return userFeatures['s4a-brand-refresh'] === 'Rollout';
};
